import React from 'react';
import { DialogContainer } from '~/src/components/Modal/mui/DialogContainer';
import { MessageDialog } from '~/src/components/Modal/mui/MessageDialog';
import Button from '~/src/components/Button';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface IdentityMigrationModalContentsProps {
  open: boolean;
  onClose: () => void;
  canClose: boolean;
  handleMigrate: () => void;
  isError: boolean;
  email: string;
}

const InfoBox: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    style={{
      backgroundColor: '#DBEAFE',
      borderRadius: '8px',
      padding: '16px',
      marginTop: '24px',
      display: 'flex',
      gap: '12px',
      alignItems: 'flex-start',
    }}
  >
    <InfoOutlinedIcon sx={{ height: '20px' }} />
    {children}
  </div>
);

const IdentityMigrationModalContents: React.FC<
  IdentityMigrationModalContentsProps
> = ({ open, onClose, canClose, handleMigrate, isError, email }) => {
  return (
    <DialogContainer open={open} onClose={onClose} canCloseWithBgClick={false}>
      <MessageDialog
        title="Update to Clio Login Now"
        onClose={onClose}
        showCloseButton={canClose}
        dialogActions={
          <>
            <Button onClick={handleMigrate} primary style={{ fontWeight: 600 }}>
              Set up Clio Login
            </Button>
            {isError && (
              <Button onClick={onClose} secondaryAlert>
                Close
              </Button>
            )}
          </>
        }
      >
        <div>
          {canClose
            ? "Starting January 13, you'll only be able to access Clio Draft through one centralized login."
            : 'You can now only access Clio Draft through one centralized login.'}{' '}
          Your account, including all your templates and documents, will stay
          exactly the same.<br></br>
          <br></br>
          You need to update your login credentials now.{' '}
          <a
            href="https://help.lawyaw.com/en/articles/11483042-clio-draft-login-resource-improvements"
            target="_blank"
            rel="noreferrer"
          >
            Learn more
          </a>
          .
          {email && (
            <div>
              <br></br>
              You will be creating a Login for <strong>{email}</strong>.
            </div>
          )}
          <InfoBox>
            <div>
              <div style={{ marginBottom: '4px' }}>
                <strong>Using a different email address to access Clio?</strong>
              </div>
              <div>
                We can simplify this for you,{' '}
                <a href="mailto:support@clio.com">contact our support team</a>{' '}
                for help.
              </div>
            </div>
          </InfoBox>
        </div>
        {isError && (
          <div style={{ marginTop: '26px', color: 'red' }}>
            <p>
              Error: Failed to connect to Clio Login. Please contact Draft
              support.
            </p>
          </div>
        )}
      </MessageDialog>
    </DialogContainer>
  );
};

export default IdentityMigrationModalContents;
